import {Source} from '../models/Source'
import Vue from 'vue';

export default class AnalyticsService {
    vue?: Vue
    source?: Source

    sourcesToTrack: Source[] = [
        Source.designmynight
    ]

    constructor(source?: Source, vue?: Vue) {
        this.source = source
        this.vue = vue
    }

    public emitEvent(eventName: string) {
        if (this.vue === undefined) {
            return;
        }

        this.vue.$emit(eventName);
    }

    public trackEvent(action: any, status: any, label: any, value: any) {
        if (!this.shouldTrackEvent()) {
            return
        }

        const ga = (<any>window).ga

        ga('create', process.env.GA_ID, process.env.GA_HOST)
        ga('send', 'event', action, status, label, value)
    }

    private shouldTrackEvent() {
        return this.isAnalyticsAvailable()
            && this.source
            && this.sourcesToTrack.indexOf(this.source) > -1
            && process.env.NODE_ENV !== 'development'
    }

    /**
     * Checks whether Google Analytics has been installed on current web page
     *
     * @private
     * @return boolean
     */
    private isAnalyticsAvailable(): boolean {
        return !!(<any>window).ga;
    }
}



// WEBPACK FOOTER //
// ./src/services/AnalyticsService.ts